'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _class, _temp2;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styles = require('./styles');
var _wavfichacertaFichacertaIcons = require('@bit/wavfichacerta.fichacerta.icons.loading-circle');
var _wavfichacertaFichacertaIcons2 = _interopRequireDefault(_wavfichacertaFichacertaIcons);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var CustomTable = (_temp2 = _class = function (_Component) {
  _inherits(CustomTable, _Component);
  function CustomTable() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, CustomTable);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomTable.__proto__ || Object.getPrototypeOf(CustomTable)).call.apply(_ref, [this].concat(args))), _this), _this.mapLines = function () {
      var lines = _this.props.lines;
      if (Array.isArray(lines) && lines.length > 0) {
        var mappedLines = _this.props.lines.map(_this.props.renderLine);
        return mappedLines;
      }
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(CustomTable, [{
    key: 'render',
    value: function render() {
      var itemsQuantity = Array.isArray(this.props.lines) && this.props.lines.length || 0;
      return _react2.default.createElement(_styles.ContainerBody, {
        loading: this.props.loading
      }, this.props.loading && _react2.default.createElement(_styles.LoadingContainer, null, _react2.default.createElement(_styles.ContainerGifLoading, null, _react2.default.createElement(_wavfichacertaFichacertaIcons2.default, null))), _react2.default.createElement(_styles.StyledTable, {
        striped: true,
        responsive: true,
        maxSize: this.props.maxSize,
        items: itemsQuantity
      }, _react2.default.createElement('thead', null, this.props.renderHeader()), _react2.default.createElement(_styles.StyledTableBody, {
        loading: this.props.loading
      }, this.mapLines())));
    }
  }]);
  return CustomTable;
}(_react.Component), _class.defaultProps = {
  loading: false,
  maxSize: 'default'
}, _temp2);
exports.default = CustomTable;